"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ordertimelimitconfigAddAndUpdate = _interopRequireDefault(require("./ordertimelimitconfig-add-and-update"));
var api = _interopRequireWildcard(require("@/api/ordertimelimitconfig.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  dicts: [],
  data: function data() {
    return {
      // 简化dataForm结构，改为直接存储字符串
      dataForm: {
        startTime: '',
        endTime: ''
      },
      // 移除rangeDataForm（不再需要）
      // 新增排序相关状态
      sortColumn: '',
      // 排序字段（驼峰格式）
      order: '',
      // 排序方式：asc/desc
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    };
  },
  components: {
    AddOrUpdate: _ordertimelimitconfigAddAndUpdate.default
  },
  created: function created() {
    this.getDataList();
  },
  methods: {
    getDictLabel: function getDictLabel(dictType, dictValue) {
      var dictList = this.dict.type[dictType] || [];
      var item = dictList.find(function (d) {
        return d.value == dictValue;
      });
      return item ? item.label : dictValue;
    },
    getDictLabels: function getDictLabels(dictType, dictValues) {
      if (!dictType || !dictValues) return dictValues;
      var dictList = this.dict.type[dictType] || [];
      var values = typeof dictValues === 'string' ? dictValues.split(',') : dictValues;
      return values.map(function (v) {
        var item = dictList.find(function (d) {
          return d.value == v;
        });
        return item ? item.label : v;
      }).join('，');
    },
    /**
     * 处理排序变化事件
     * @param {Object} param 排序参数 {prop: 字段名, order: 排序方式}
     */
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      if (order) {
        this.sortColumn = this.camelToUnderline(prop); // 驼峰格式的字段名
        this.order = order === 'ascending' ? 'asc' : 'desc'; // 转换为后端需要的格式
      } else {
        // 取消排序
        this.sortColumn = '';
        this.order = '';
      }
      this.pageIndex = 1; // 排序切换后重置页码
      this.getDataList(); // 重新获取数据
    },
    // 驼峰转下划线的工具函数（核心）
    camelToUnderline: function camelToUnderline(str) {
      // 处理空值，避免报错
      if (!str) return '';
      // 1. 匹配大写字母，在前面加下划线 2. 全部转为小写 3. 去除开头可能多余的下划线
      return str.replace(/[A-Z]/g, function (match) {
        return "_".concat(match.toLowerCase());
      }).replace(/^_/, '');
    },
    search: function search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList: function getDataList() {
      var _this = this;
      this.dataListLoading = true;

      // 简化查询参数组装逻辑
      var queryParams = _objectSpread(_objectSpread({}, this.dataForm), this.sortColumn ? {
        sortColumn: this.sortColumn,
        order: this.order
      } : {});
      console.log('搜索参数:', queryParams); // 调试用

      api.ordertimelimitconfigListApi(_objectSpread(_objectSpread({}, queryParams), {}, {
        page: this.pageIndex,
        limit: this.pageSize
      })).then(function (res) {
        _this.dataListLoading = false;
        _this.total = res.recordCount;
        _this.dataList = res.recordList;
      }).catch(function () {
        _this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle: function sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    resetQuery: function resetQuery() {
      this.pageIndex = 1;

      // 重置表单数据（简化）
      this.dataForm = {
        startTime: '',
        endTime: ''
      };

      // 重置排序状态
      this.sortColumn = '';
      this.order = '';
      this.$refs['queryForm'].resetFields();
      this.getDataList();
    },
    // 当前页
    currentChangeHandle: function currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle: function selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 新增 / 修改
    addOrUpdateHandle: function addOrUpdateHandle(id) {
      var _this2 = this;
      this.addOrUpdateVisible = true;
      this.$nextTick(function () {
        _this2.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle: function deleteHandle(id) {
      var _this3 = this;
      this.$confirm("\u786E\u8BA4\u5220\u9664\u5417?", '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        api.ordertimelimitconfigDeleteApi({
          id: id // 保持小写id，与参考示例完全一致
        }).then(function (res) {
          _this3.$message.success('删除成功！');
          _this3.resetQuery();
        });
      });
    }
  }
};